export const holdEventTypes = [
  { id: 0, name: 'Other' },
  { id: 1, name: 'Personal' },
  { id: 2, name: 'Maintenance' },
  { id: 3, name: 'Pending' },
  { id: 4, name: 'Confirmed' },
]
